import React, { useMemo } from 'react'

const isDemoEnv = () => useMemo<boolean>(() => ['local', 'demo'].includes(process.env.NEXT_PUBLIC_ENVIRONMENT_NAME), [])

/**
 * controls whether children should be rendered depending if env is demo or not 
 * @param props.render if true, only renders children if env is demo; if false, renders children unless env is demo
 * @returns children or null
 */
const DemoRender = (props: { render: boolean; children: any }) => {
    const shouldRender = useMemo<boolean>(() => isDemoEnv() ? props.render : !props.render, [props.render])
    const content = useMemo(() => shouldRender ? <>{props.children}</> : null, [shouldRender])
    return content
}

const getDemoUserSignUpData = (securityQuestions?: string[]) => {
    return {
        inviteCode: '123456',
        password: 'F4GIpass',
        securityQuestionQuestion: securityQuestions ? securityQuestions[0]: 'Question',
        securityQuestionAnswer: 'Answer',
        routingNumber: '123456789',
        accountNumber: '123456789',
        addressLine1:'1354 Locust Court',
        state:'CA',
        postalCode:'90808',
        city:'Long Beach',
        firstName: 'John',
        lastName: 'Doe',
        accountPurpose: 'World Peace',
        email: 'johndoe@f4gidemoenv.com',
        phoneNumber: '+15858585858',
    }
}

export { isDemoEnv, DemoRender, getDemoUserSignUpData }